var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBattery0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 12,
    viewBox: "0 0 25 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33854 1.33398H20.0052C20.9257 1.33398 21.6719 2.08018 21.6719 3.00065V9.00065C21.6719 9.92113 20.9257 10.6673 20.0052 10.6673H3.33854C2.41807 10.6673 1.67188 9.92113 1.67188 9.00065V3.00065C1.67188 2.08018 2.41807 1.33398 3.33854 1.33398ZM0.671875 3.00065C0.671875 1.52789 1.86578 0.333984 3.33854 0.333984H20.0052C21.478 0.333984 22.6719 1.52789 22.6719 3.00065V9.00065C22.6719 10.4734 21.478 11.6673 20.0052 11.6673H3.33854C1.86578 11.6673 0.671875 10.4734 0.671875 9.00065V3.00065ZM24.9998 6.0007C24.9998 6.87384 24.4765 7.66193 23.6718 8.0007V4.0007C24.4765 4.33948 24.9998 5.12757 24.9998 6.0007Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.67188,
    y: 2.33398,
    width: 18,
    height: 7.33333,
    rx: 1.33333,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery0);
export default __webpack_public_path__ + "static/media/battery0.7ad33429305132dc563d0365884a92bd.svg";
export { ForwardRef as ReactComponent };